import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: 'app-taco-tuesdays',
  templateUrl: './taco-tuesdays.component.html',
  styleUrls: ['./taco-tuesdays.component.scss']
})
export class TacoTuesdaysComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/taco-tuesdays/taco-tuesdays.component.ts